/**
 * isFunction: Check if value is a Function
 *
 * Functions are functions so here just typeof is enough.
 *
 * @return {Boolean}
 */

export const isFunction = (value) => {
  return typeof value === 'function'
}
